import React, { useState, useEffect, useCallback } from 'react';
import CampoDataHora from '../components/CampoDataHora';
import { useNavigate } from 'react-router-dom';
import SelectColaborador from '../components/SelectColaborador';
import ModalConfirmar from '../components/ModalConfirmar';
import AgendarMensagemCliente from '../components/AgendarMensagemCliente';

function token() { return localStorage.getItem('token'); }
function isAdmin() { return localStorage.getItem('nomeUsuario') === 'Vagner Freitas'; }

const inp = {
  width: '100%', padding: '3px 6px', borderRadius: 3,
  border: '1px solid #b0b8c4', fontSize: 13, color: '#111',
  boxSizing: 'border-box', background: '#fff', height: 26,
};

const lbl = { fontSize: 12, fontWeight: 600, color: '#374151', whiteSpace: 'nowrap', paddingRight: 6 };

function parseDataHora(val) {
  if (!val) return { data: '', hora: '' };
  const [data, hora] = val.includes('T') ? val.split('T') : [val, ''];
  return { data, hora: hora ? hora.slice(0, 5) : '' };
}
function combinarDataHora(data, hora) {
  if (!data) return '';
  return hora ? `${data}T${hora}` : data;
}
function DataHoraInput({ value, onChange }) {
  const { data, hora } = parseDataHora(value);
  function handleHora(e) {
    let v = e.target.value.replace(/[^0-9:]/g, '');
    if (/^\d{4}$/.test(v)) v = v.slice(0, 2) + ':' + v.slice(2);
    onChange(combinarDataHora(data, v));
  }
  return (
    <div style={{ display: 'flex', gap: 6, flex: 1 }}>
      <input type="date" value={data}
        onChange={e => onChange(combinarDataHora(e.target.value, hora))}
        style={{ ...inp, flex: 1 }} />
      <input type="text" value={hora} placeholder="HH:MM" maxLength={5}
        onChange={handleHora}
        style={{ ...inp, width: 70, flex: 'none' }} />
    </div>
  );
}

function SectionHeader({ children }) {
  return (
    <div style={{ background: '#e8edf2', borderLeft: '3px solid #0a1628', padding: '3px 10px', fontSize: 12, fontWeight: 700, color: '#0a1628', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 2 }}>
      {children}
    </div>
  );
}

function BtnPrimary({ children, ...props }) {
  return (
    <button {...props} style={{ background: '#0a1628', color: '#fff', padding: '4px 14px', fontSize: 12, fontWeight: 600, borderRadius: 4, border: 'none', cursor: 'pointer', ...(props.style || {}) }}>
      {children}
    </button>
  );
}

function BtnCancel({ children, ...props }) {
  return (
    <button {...props} style={{ background: '#f3f4f6', color: '#374151', padding: '4px 12px', fontSize: 12, borderRadius: 4, border: '1px solid #d1d5db', cursor: 'pointer' }}>
      {children}
    </button>
  );
}

const TAREFA_NOVA = { descricao: '', data_agendada: '', destinado_a: '', realizado: '', subagenda: '', lembrarWa: false };

// Subagendas: classificação da tarefa pro modo painel (o modo é só do
// Vagner, mas qualquer um pode classificar na criação da tarefa)
const SUBAGENDAS = [
  { key: 'administrativo', label: 'Administrativo', icone: '🗂️', cor: '#d97706' },
  { key: 'comercial', label: 'Comercial', icone: '💼', cor: '#3b82f6' },
  { key: 'cliente', label: 'Cliente', icone: '👥', cor: '#16a34a' },
  { key: 'demandas', label: 'Demandas Processuais', icone: '⚖️', cor: '#8b5cf6' },
  { key: 'pessoal', label: 'Pessoal', icone: '🏠', cor: '#ec4899' },
  { key: '', label: 'Geral', icone: '📥', cor: '#6b7280' },
];
const chipSub = (on, cor) => ({ padding: '2px 10px', borderRadius: 3, fontSize: 12, fontWeight: on ? 700 : 400, border: '1px solid', borderColor: on ? cor : '#d1d5db', background: on ? cor : '#fff', color: on ? '#fff' : '#374151', cursor: 'pointer' });
const modalBase = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 };

function fmtDt(iso) {
  if (!iso) return '—';
  // Data que o JS não entende (ex.: ano digitado errado) não pode derrubar a
  // tela — mostra o valor cru pra pessoa enxergar e corrigir.
  if (isNaN(new Date(iso.includes('T') ? iso : iso + 'T12:00:00').getTime())) return `⚠ ${iso}`;
  if (iso.includes('T')) {
    const d = new Date(iso);
    const brt = new Date(d.getTime() - 3 * 60 * 60 * 1000);
    const [datePart, timePart] = brt.toISOString().split('T');
    const [ano, mes, dia] = datePart.split('-');
    return `${dia}/${mes}/${ano.slice(2)} ${timePart.slice(0, 5)}`;
  }
  const [ano, mes, dia] = iso.split('-');
  return `${dia}/${mes}/${ano.slice(2)}`;
}

function statusTarefa(t) {
  if (t.realizado) return { label: 'Feito', cor: '#16a34a', bg: '#f0fdf4' };
  if (!t.data_agendada) return { label: 'Sem data', cor: '#9ca3af', bg: '#f9fafb' };
  const dStr = t.data_agendada.slice(0, 10);
  const hojeLocal = new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString().slice(0, 10);
  if (dStr < hojeLocal) return { label: 'Atrasada', cor: '#dc2626', bg: '#fef2f2' };
  return { label: 'Pendente', cor: '#d97706', bg: '#fffbeb' };
}

// Navegador de dia (‹ Domingo, 12/07/2026 ›) — mesmo controle do calendário
const somarDia = (iso, n) => { const d = new Date(iso + 'T12:00:00Z'); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); };
const nomeDiaLongo = (iso) => new Date(iso + 'T12:00:00').toLocaleDateString('pt-BR', { weekday: 'long' });
const fmtDiaCompleto = (iso) => `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}`;

export default function Agenda() {
  const navigate = useNavigate();
  const [tarefas, setTarefas] = useState([]);
  const [filtroResponsavel, setFiltroResponsavel] = useState(localStorage.getItem('nomeUsuario') || '');
  // Abre direto nas pendentes (dá pra trocar pra qualquer outro quando quiser)
  const [filtroStatus, setFiltroStatus] = useState('Pendente');
  const [filtroDataDe, setFiltroDataDe] = useState('');
  const [filtroDataAte, setFiltroDataAte] = useState('');
  const [filtroPeriodo, setFiltroPeriodo] = useState('hoje');
  // Dia selecionado do navegador ‹ › (ativa o modo 'dia' do período)
  const [diaSel, setDiaSel] = useState(() => new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString().slice(0, 10));
  const [mostrarFuturas, setMostrarFuturas] = useState(false);
  const [responsaveis, setResponsaveis] = useState([]);

  const [modal, setModal] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [buscaCliente, setBuscaCliente] = useState('');
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [form, setForm] = useState({ ...TAREFA_NOVA, destinado_a: localStorage.getItem('nomeUsuario') || '' });
  const [salvando, setSalvando] = useState(false);

  const [modalCalendario, setModalCalendario] = useState(false);
  const [mesCalendario, setMesCalendario] = useState(() => { const h = new Date(); return { ano: h.getFullYear(), mes: h.getMonth() }; });
  const [diaExpandido, setDiaExpandido] = useState(null);
  const [telefonesCache, setTelefonesCache] = useState({});

  const [modalTransferir, setModalTransferir] = useState(false);
  // Modo subagendas (painéis lado a lado — só Vagner) + filtro na lista
  const [modoSub, setModoSub] = useState(() => localStorage.getItem('agendaModoSub') === '1');
  const [filtroSubagenda, setFiltroSubagenda] = useState('todas');
  const [tarefaAcao, setTarefaAcao] = useState(null); // clique numa tarefa do painel
  const [arrastandoTarefa, setArrastandoTarefa] = useState(null); // drag & drop entre painéis
  const [sobreSub, setSobreSub] = useState(null);

  // Soltar o card em outro painel = trocar a subagenda (igual ao Kanban do CRM)
  async function soltarNaSubagenda(sub) {
    const t = arrastandoTarefa;
    setSobreSub(null);
    setArrastandoTarefa(null);
    if (!t || (t.subagenda || '') === sub) return;
    setTarefas(prev => prev.map(x => x._id === t._id ? { ...x, subagenda: sub } : x)); // otimista
    await fetch(`/agenda/${t._id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ descricao: t.descricao, data_agendada: t.data_agendada, destinado_a: t.destinado_a, realizado: t.realizado || '', subagenda: sub }),
    }).catch(() => {});
    carregar();
  }
  const [dataOrigem, setDataOrigem] = useState('');
  // 'atrasadas' = todas as pendentes antes de hoje (sem precisar saber o dia);
  // 'dia' = o modo antigo, com data de origem específica
  const [modoTransferir, setModoTransferir] = useState('atrasadas');
  // Toast que some sozinho (aviso de tarefa avulsa criada)
  const [avisoToast, setAvisoToast] = useState('');
  const [dataDestino, setDataDestino] = useState('');
  const [transferindo, setTransferindo] = useState(false);

  async function buscarTelefone(clienteId) {
    if (!clienteId || telefonesCache[clienteId] !== undefined) return;
    try {
      const r = await fetch(`/clientes/${clienteId}`, { headers: { Authorization: `Bearer ${token()}` } });
      const c = await r.json();
      setTelefonesCache(prev => ({ ...prev, [clienteId]: c.telefone || '' }));
    } catch { setTelefonesCache(prev => ({ ...prev, [clienteId]: '' })); }
  }

  async function buscarTelefoneOportunidade(opId) {
    const key = `op_${opId}`;
    if (!opId || (telefonesCache[key] !== undefined && etapaOps[opId] !== undefined)) return;
    try {
      const r = await fetch(`/oportunidades/${opId}`, { headers: { Authorization: `Bearer ${token()}` } });
      const op = await r.json();
      setTelefonesCache(prev => ({ ...prev, [key]: op.telefone || '' }));
      setEtapaOps(prev => ({ ...prev, [opId]: op.etapa || '' }));
    } catch { setTelefonesCache(prev => ({ ...prev, [`op_${opId}`]: '' })); }
  }

  // Etapa do CRM por oportunidade (modal da tarefa mostra e move a coluna)
  const [etapaOps, setEtapaOps] = useState({});
  async function mudarEtapaOp(opId, nova) {
    const r = await fetch(`/oportunidades/${opId}/etapa`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ etapa: nova }),
    }).catch(() => null);
    if (!r || !r.ok) return alert('Não consegui mover a etapa no CRM.');
    setEtapaOps(prev => ({ ...prev, [opId]: nova }));
  }

  // Modal da tarefa: busca o telefone do cliente/oportunidade em segundo
  // plano assim que abre (mesmo cache dos painéis)
  useEffect(() => {
    if (!tarefaAcao) return;
    if (tarefaAcao.cliente_id) buscarTelefone(tarefaAcao.cliente_id);
    // Oportunidade sempre buscada quando existe: traz telefone E etapa do CRM
    if (tarefaAcao.oportunidade_id) buscarTelefoneOportunidade(tarefaAcao.oportunidade_id);
  }, [tarefaAcao]);

  function copiarTelefone(tel) {
    const num = tel.replace(/\D/g, '');
    if (navigator.clipboard) {
      navigator.clipboard.writeText(num).catch(() => { const el = document.createElement('textarea'); el.value = num; document.body.appendChild(el); el.select(); document.execCommand('copy'); document.body.removeChild(el); });
    } else { const el = document.createElement('textarea'); el.value = num; document.body.appendChild(el); el.select(); document.execCommand('copy'); document.body.removeChild(el); }
  }

  // ⭐ Favorita: destaque da tarefa, visível no filtro Favoritas em qualquer dia
  async function alternarFavorita(t) {
    const nova = !t.favorita;
    setTarefas(prev => prev.map(x => x._id === t._id ? { ...x, favorita: nova } : x));
    await fetch(`/agenda/${t._id}/favorita`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ favorita: nova }),
    }).catch(() => {});
  }

  // 🔴 Urgente: mesma mecânica da favorita — a linha fica vermelha e a tarefa
  // aparece no filtro Urgente em qualquer dia
  async function alternarUrgente(t) {
    const novo = !t.urgente;
    setTarefas(prev => prev.map(x => x._id === t._id ? { ...x, urgente: novo } : x));
    await fetch(`/agenda/${t._id}/urgente`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ urgente: novo }),
    }).catch(() => {});
  }

  const [tarefaFeito, setTarefaFeito] = useState(null);
  const [textoRealizado, setTextoRealizado] = useState('');
  const [marcandoFeito, setMarcandoFeito] = useState(false);
  const [confirmExcluir, setConfirmExcluir] = useState(null);
  // "✓ Feito + nova tarefa": conclui e já abre a próxima com o mesmo vínculo
  const [proximaDe, setProximaDe] = useState(null); // tarefa de origem
  const [proxima, setProxima] = useState({ descricao: '', data_agendada: '', destinado_a: '', favorita: false, urgente: false });
  const [salvandoProxima, setSalvandoProxima] = useState(false);
  // ➜ Adiar: muda a data individualmente, sempre pra frente (nunca passado)
  const [adiarTarefa, setAdiarTarefa] = useState(null);
  const [novaDataAdiar, setNovaDataAdiar] = useState('');
  const [erroAdiar, setErroAdiar] = useState('');
  const [adiando, setAdiando] = useState(false);

  // 💬 Mensagem agendada PRO CLIENTE (usa a fila da Comunicação)
  const [msgAlvo, setMsgAlvo] = useState(null);

  function abrirMsgCliente(t) {
    // Abre NA HORA — o telefone chega em seguida, buscado pelo próprio modal
    setTarefaAcao(null);
    setMsgAlvo({
      cliente_id: t.cliente_id || '',
      oportunidade_id: t.oportunidade_id || '',
      cliente_nome: t.cliente_nome || t.oportunidade_nome || '',
      telefone: '',
    });
  }

  // 🔔 Lembrete no WhatsApp: escolhe data e hora e o sistema avisa na hora certa
  const [lembreteTarefa, setLembreteTarefa] = useState(null);
  const [quandoLembrete, setQuandoLembrete] = useState('');
  const [erroLembrete, setErroLembrete] = useState('');
  const [salvandoLembrete, setSalvandoLembrete] = useState(false);

  // "agora" no formato do input datetime-local, no fuso da Paraíba
  const agoraLocal = () => new Date(Date.now() - 3 * 3600000).toISOString().slice(0, 16);

  function abrirLembrete(t) {
    setTarefaAcao(null);
    setErroLembrete('');
    // Sugestão: tarefa com hora marcada → 1h antes; só com data → 9h daquele dia
    let sugestao = '';
    const da = t.data_agendada || '';
    if (da.length > 10) {
      const d = new Date(da.slice(0, 16) + ':00');
      d.setHours(d.getHours() - 1);
      sugestao = new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
    } else if (da) {
      sugestao = da.slice(0, 10) + 'T09:00';
    }
    setQuandoLembrete(t.lembrete_em || (sugestao > agoraLocal() ? sugestao : ''));
    setLembreteTarefa(t);
  }

  async function confirmarLembrete() {
    if (!quandoLembrete) return setErroLembrete('Escolha a data e a hora do lembrete.');
    if (quandoLembrete <= agoraLocal()) return setErroLembrete('Escolha um horário no futuro.');
    setSalvandoLembrete(true);
    const r = await fetch(`/agenda/${lembreteTarefa._id}/lembrete`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ lembrete_em: quandoLembrete }),
    }).then(x => x.json()).catch(() => ({ erro: 'Falha ao salvar o lembrete.' }));
    setSalvandoLembrete(false);
    if (r.erro) return setErroLembrete(r.erro);
    setLembreteTarefa(null);
    carregar();
  }

  async function cancelarLembrete() {
    setSalvandoLembrete(true);
    await fetch(`/agenda/${lembreteTarefa._id}/lembrete`, {
      method: 'DELETE', headers: { Authorization: `Bearer ${token()}` },
    }).catch(() => {});
    setSalvandoLembrete(false);
    setLembreteTarefa(null);
    carregar();
  }

  async function confirmarAdiar() {
    const t = adiarTarefa;
    const hoje = brtStr();
    const dataAtual = (t.data_agendada || '').slice(0, 10);
    // Regra: nova data > data atual da tarefa E nunca antes de hoje
    const minimo = dataAtual && dataAtual >= hoje ? somarDia(dataAtual, 1) : hoje;
    if (!novaDataAdiar) return setErroAdiar('Escolha a nova data.');
    if (novaDataAdiar < minimo) {
      return setErroAdiar(dataAtual && dataAtual >= hoje
        ? `Só pra frente: a nova data precisa ser depois de ${fmtDt(dataAtual)}.`
        : 'A nova data não pode ficar no passado.');
    }
    setAdiando(true);
    // Hora cortada no formato do input (datas antigas vinham com segundos/fuso)
    const hora = t.data_agendada && t.data_agendada.includes('T') ? ('T' + t.data_agendada.split('T')[1]).slice(0, 6) : '';
    const r = await fetch(`/agenda/${t._id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ descricao: t.descricao, data_agendada: novaDataAdiar + hora, destinado_a: t.destinado_a, realizado: t.realizado || '' }),
    }).catch(() => null);
    setAdiando(false);
    if (!r || !r.ok) {
      let det = ''; try { det = (await r.json()).erro || ''; } catch { /* não-JSON */ }
      return setErroAdiar(`Não consegui adiar (HTTP ${r?.status || 'rede'}). ${det}`.trim());
    }
    setAdiarTarefa(null);
    carregar();
  }

  const carregar = useCallback(() => {
    fetch('/agenda', { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json())
      .then(data => {
        setTarefas(data);
        const nomeLogado = localStorage.getItem('nomeUsuario') || '';
        const resp = [...new Set([nomeLogado, ...data.map(t => t.destinado_a)].filter(Boolean))].sort();
        setResponsaveis(resp);
      })
      .catch(() => {});
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  useEffect(() => {
    tarefas.forEach(t => {
      if (t.cliente_id) buscarTelefone(t.cliente_id);
      if (t.oportunidade_id) buscarTelefoneOportunidade(t.oportunidade_id);
    });
  }, [tarefas]); // eslint-disable-line

  function abrirModal() {
    setForm({ ...TAREFA_NOVA, destinado_a: localStorage.getItem('nomeUsuario') || '' });
    setClienteSelecionado(null);
    setBuscaCliente('');
    setModal(true);
    fetch('/clientes', { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(setClientes).catch(() => {});
  }

  const clientesFiltrados = clientes.filter(c => {
    const busca = buscaCliente.toLowerCase();
    return !busca || (c.nome || '').toLowerCase().includes(busca) ||
      (c.processos?.[0]?.nome_marca || '').toLowerCase().includes(busca) ||
      (c.processos?.[0]?.numero_processo || '').includes(busca);
  }).slice(0, 8);

  async function salvarTarefa() {
    if (!form.descricao.trim()) return alert('Preencha a descrição da tarefa.');
    // Sem cliente e/ou sem destinatário é permitido: vira tarefa avulsa —
    // cria direto, fecha o modal e avisa num toast que some sozinho
    setSalvando(true);
    const criada = await fetch('/agenda', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify({
        ...form,
        cliente_id: clienteSelecionado?._id || '',
        cliente_nome: clienteSelecionado ? (clienteSelecionado.nome || clienteSelecionado.processos?.[0]?.nome_marca || '') : '',
      }),
    }).then(r => r.json()).catch(() => null);
    // 🔔 Lembrete no WhatsApp 30min antes — mesmo motor do cadastro do cliente
    let avisoLembrete = '';
    if (form.lembrarWa && criada?._id) {
      if (!String(form.data_agendada || '').includes('T') || !form.data_agendada.slice(11)) {
        avisoLembrete = '⚠️ Tarefa salva, mas o lembrete precisa de HORA — marque pelo botão 🔔 da lista.';
      } else {
        const quando = new Date(new Date(form.data_agendada).getTime() - 30 * 60000);
        const p2 = (n) => String(n).padStart(2, '0');
        const iso = `${quando.getFullYear()}-${p2(quando.getMonth() + 1)}-${p2(quando.getDate())}T${p2(quando.getHours())}:${p2(quando.getMinutes())}`;
        const r = await fetch(`/agenda/${criada._id}/lembrete`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
          body: JSON.stringify({ lembrete_em: iso }),
        }).catch(() => null);
        avisoLembrete = (r && r.ok)
          ? `🔔 Aviso no WhatsApp às ${p2(quando.getHours())}:${p2(quando.getMinutes())} (30 min antes).`
          : '⚠️ Tarefa salva, mas o lembrete falhou — tente pelo botão 🔔 da lista.';
      }
    }
    setSalvando(false);
    setModal(false);

    const semCliente = !clienteSelecionado;
    const semDestinatario = !(form.destinado_a || '').trim();
    if (semCliente || semDestinatario || avisoLembrete) {
      const partes = [semCliente && 'sem cliente vinculado', semDestinatario && 'sem destinatário'].filter(Boolean).join(' e ');
      const base = (semCliente || semDestinatario) ? `✓ Tarefa avulsa criada — ${partes}.` : '';
      setAvisoToast([base, avisoLembrete].filter(Boolean).join(' '));
      setTimeout(() => setAvisoToast(''), 6000);
    }
    carregar();
  }

  // Mesma regra de visibilidade da lista: com responsável filtrado, tarefa
  // de OUTRA pessoa fica de fora (transferir/calendário puxavam de todos)
  const visivelPraMim = (t) => !filtroResponsavel || !t.destinado_a || t.destinado_a === filtroResponsavel;

  async function transferirTarefas() {
    if (modoTransferir === 'dia' && !dataOrigem) return alert('Selecione a data de origem.');
    if (!dataDestino) return alert('Selecione a data de destino.');
    const pendentes = modoTransferir === 'atrasadas'
      ? atrasadas
      : tarefas.filter(t => visivelPraMim(t) && !t.realizado && t.data_agendada && t.data_agendada.slice(0, 10) === dataOrigem);
    if (pendentes.length === 0) return alert(modoTransferir === 'atrasadas' ? 'Nenhuma tarefa atrasada. 🎉' : 'Nenhuma tarefa pendente nessa data de origem.');
    setTransferindo(true);
    await Promise.all(pendentes.map(t => {
      const horaAtual = t.data_agendada.includes('T') ? t.data_agendada.split('T')[1] : '';
      const novaData = horaAtual ? `${dataDestino}T${horaAtual}` : dataDestino;
      return fetch(`/agenda/${t._id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
        body: JSON.stringify({ ...t, data_agendada: novaData }),
      });
    }));
    setTransferindo(false);
    setModalTransferir(false);
    setDataOrigem('');
    setDataDestino('');
    carregar();
  }

  async function excluirTarefa(id) {
    await fetch(`/agenda/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token()}` } });
    setConfirmExcluir(null);
    carregar();
  }

  async function confirmarFeito(abrirProxima = false) {
    if (!tarefaFeito) return;
    setMarcandoFeito(true);
    // Erro do servidor aparece na tela — antes falhava mudo e a tarefa "não saía"
    const r = await fetch(`/agenda/${tarefaFeito._id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ descricao: tarefaFeito.descricao, data_agendada: tarefaFeito.data_agendada, destinado_a: tarefaFeito.destinado_a, realizado: textoRealizado.trim() || 'Concluído' }),
    }).catch(() => null);
    setMarcandoFeito(false);
    if (!r || !r.ok) {
      let det = ''; try { det = (await r.json()).erro || ''; } catch { /* não-JSON */ }
      return alert(`Não consegui marcar como feito (HTTP ${r?.status || 'rede'}). ${det}`.trim());
    }
    if (abrirProxima) {
      // Próxima tarefa herda o vínculo e o responsável da que acabou de fechar
      setProximaDe(tarefaFeito);
      setProxima({ descricao: '', data_agendada: '', destinado_a: tarefaFeito.destinado_a || localStorage.getItem('nomeUsuario') || '', favorita: false, urgente: false, subagenda: tarefaFeito.subagenda || '' });
    }
    setTarefaFeito(null);
    carregar();
  }

  async function salvarProxima() {
    if (!proxima.descricao.trim()) return alert('Descreva a nova tarefa.');
    setSalvandoProxima(true);
    await fetch('/agenda', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify({
        ...proxima,
        descricao: proxima.descricao.trim(),
        cliente_id: proximaDe?.cliente_id || '',
        cliente_nome: proximaDe?.cliente_nome || '',
        oportunidade_id: proximaDe?.oportunidade_id || '',
        oportunidade_nome: proximaDe?.oportunidade_nome || '',
      }),
    }).catch(() => {});
    setSalvandoProxima(false);
    setProximaDe(null);
    carregar();
  }

  // BRT = UTC-3; subtrair 3h garante data correta à noite
  const brtStr = (d = new Date()) => new Date(d.getTime() - 3 * 60 * 60 * 1000).toISOString().slice(0, 10);
  const hojeStr = brtStr();
  const filtroDataAtiva = !!(filtroDataDe || filtroDataAte);
  // Atrasadas: pendentes com data antes de hoje — não importa de que dia
  // vieram, o modo "atrasadas" do transferir pega todas de uma vez
  const atrasadas = tarefas.filter(t => visivelPraMim(t) && !t.realizado && t.data_agendada && t.data_agendada.slice(0, 10) < hojeStr);

  function aplicarPeriodo(periodo) {
    setFiltroPeriodo(periodo);
    setFiltroDataDe('');
    setFiltroDataAte('');
    setMostrarFuturas(periodo === 'todos');
    // "Hoje" também traz o navegador de dia de volta pra data de hoje
    if (periodo === 'hoje') setDiaSel(hojeStr);
  }

  // ‹ › do navegador: escolhe o dia e liga o modo 'dia'
  function irParaDia(iso) {
    setDiaSel(iso);
    setFiltroPeriodo('dia');
    setFiltroDataDe('');
    setFiltroDataAte('');
    setMostrarFuturas(false);
  }

  const tarefasFiltradas = tarefas.filter(t => {
    if (filtroResponsavel && t.destinado_a && t.destinado_a !== filtroResponsavel) return false;
    if (filtroSubagenda !== 'todas' && (t.subagenda || '') !== filtroSubagenda) return false;
    if (filtroStatus) {
      const lbl = statusTarefa(t).label;
      // "Pendente" = tudo que ainda não foi feito — INCLUI as Atrasadas.
      // Sem isso, a tarefa não realizada "sumia" da tela quando o dia virava
      // (o rótulo troca de Pendente pra Atrasada e o filtro padrão escondia).
      if (filtroStatus === 'Pendente' ? (lbl !== 'Pendente' && lbl !== 'Atrasada') : lbl !== filtroStatus) return false;
    }
    // ⭐ Favoritas: mostra TODAS as favoritas, independente do dia
    if (filtroPeriodo === 'favoritas') return !!t.favorita;
    // 🔴 Urgentes: mesma lógica das favoritas
    if (filtroPeriodo === 'urgentes') return !!t.urgente;
    // Navegador de dia: tudo que está agendado PRO dia escolhido, feito ou não
    // (vem antes da regra do realizado, senão as concluídas do dia sumiriam)
    if (filtroPeriodo === 'dia' && !filtroDataDe && !filtroDataAte) {
      return (t.data_agendada || '').slice(0, 10) === diaSel;
    }
    if (t.realizado) {
      if (!t.concluido_em) return false;
      return brtStr(new Date(t.concluido_em)) === hojeStr;
    }
    if (filtroDataDe || filtroDataAte) {
      const d = t.data_agendada ? t.data_agendada.slice(0, 10) : null;
      if (!d) return false;
      if (filtroDataDe && d < filtroDataDe) return false;
      if (filtroDataAte && d > filtroDataAte) return false;
    } else if (filtroPeriodo !== 'todos') {
      const d = t.data_agendada ? t.data_agendada.slice(0, 10) : null;
      if (!d) return filtroPeriodo === 'hoje';
      if (filtroPeriodo === 'hoje') return d <= hojeStr;
      if (filtroPeriodo === 'ontem') return d === brtStr(new Date(Date.now() - 86400000));
      if (filtroPeriodo === '7dias') return d >= brtStr(new Date(Date.now() - 6 * 86400000)) && d <= hojeStr;
      if (filtroPeriodo === 'mes') return d.slice(0, 7) === hojeStr.slice(0, 7);
    }
    return true;
  }).sort((a, b) => {
    // Prioridade fixa: 🔴 urgentes → ⭐ favoritas → comuns com horário → sem horário
    const nivel = (t) => t.urgente ? 0 : t.favorita ? 1 : (t.data_agendada || '').includes('T') ? 2 : 3;
    if (nivel(a) !== nivel(b)) return nivel(a) - nivel(b);
    // Dentro de cada grupo, mantém a ordem por data de sempre
    if (!a.data_agendada) return 1;
    if (!b.data_agendada) return -1;
    // No dia escolhido a leitura é de agenda: manhã em cima, tarde embaixo
    if (filtroPeriodo === 'dia') return new Date(a.data_agendada) - new Date(b.data_agendada);
    return new Date(b.data_agendada) - new Date(a.data_agendada);
  });

  // Contadores acompanham os filtros de responsável e subagenda (mas não os
  // de status/período) — senão o topo diz "Atrasadas: 65" e o filtro
  // Atrasada mostra vazio quando as atrasadas são de outra pessoa/subagenda
  const tarefasBase = tarefas.filter(t => {
    if (filtroResponsavel && t.destinado_a && t.destinado_a !== filtroResponsavel) return false;
    if (filtroSubagenda !== 'todas' && (t.subagenda || '') !== filtroSubagenda) return false;
    return true;
  });
  const cont = {
    total: tarefasBase.length,
    pendentes: tarefasBase.filter(t => statusTarefa(t).label === 'Pendente').length,
    atrasadas: tarefasBase.filter(t => statusTarefa(t).label === 'Atrasada').length,
    concluidas: tarefasBase.filter(t => statusTarefa(t).label === 'Feito').length,
  };

  return (
    <div style={{ maxWidth: modoSub && isAdmin() ? 1500 : 960 }}>

      {/* Toast de confirmação (some sozinho em 5s) */}
      {avisoToast && (
        <div style={{ position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)', background: '#0a1628', color: '#fff', borderRadius: 8, padding: '10px 18px', fontSize: 13, fontWeight: 600, boxShadow: '0 8px 24px rgba(0,0,0,0.3)', zIndex: 2000, maxWidth: '90vw' }}>
          {avisoToast}
        </div>
      )}

      {/* Cabeçalho */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10, flexWrap: 'wrap', gap: 8 }}>
        <h1 style={{ fontSize: 17, fontWeight: 700, color: '#0a1628', margin: 0 }}>Agenda</h1>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {isAdmin() && (
            <BtnCancel onClick={() => { const v = !modoSub; setModoSub(v); localStorage.setItem('agendaModoSub', v ? '1' : '0'); }}>
              {modoSub ? '📋 Modo lista' : '🗂️ Modo subagendas'}
            </BtnCancel>
          )}
          <BtnCancel onClick={() => setModalCalendario(true)}>📅 Calendário</BtnCancel>
          <BtnCancel onClick={() => { setModoTransferir(atrasadas.length ? 'atrasadas' : 'dia'); setDataOrigem(''); setDataDestino(hojeStr); setModalTransferir(true); }}>📦 Transferir tarefas</BtnCancel>
          {atrasadas.length > 0 && (
            <button onClick={() => { setModoTransferir('atrasadas'); setDataOrigem(''); setDataDestino(hojeStr); setModalTransferir(true); }}
              title="Pendentes com data antes de hoje, de qualquer dia — um clique traz todas pra hoje"
              style={{ background: '#fffbeb', color: '#b45309', border: '1px solid #fde68a', borderRadius: 6, padding: '5px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
              ⏰ {atrasadas.length} atrasada(s) → trazer pra hoje
            </button>
          )}
          <BtnPrimary onClick={abrirModal}>+ Nova Tarefa</BtnPrimary>
        </div>
      </div>

      {/* Resumo compacto */}
      <div style={{ background: '#fff', border: '1px solid #c8d0da', borderRadius: 4, padding: '6px 14px', marginBottom: 8, display: 'flex', gap: 24, fontSize: 13, flexWrap: 'wrap' }}>
        <span style={{ color: '#374151' }}>Total: <strong>{cont.total}</strong></span>
        <span style={{ color: '#d97706' }}>Pendentes: <strong>{cont.pendentes}</strong></span>
        <span style={{ color: '#dc2626' }}>Atrasadas: <strong>{cont.atrasadas}</strong></span>
        <span style={{ color: '#16a34a' }}>Concluídas hoje: <strong>{cont.concluidas}</strong></span>
      </div>

      {/* Filtros */}
      <div style={{ background: '#fff', border: '1px solid #c8d0da', borderRadius: 4, marginBottom: 8 }}>
        <SectionHeader>Filtros</SectionHeader>
        <div style={{ padding: '6px 10px', display: 'flex', flexDirection: 'column', gap: 0 }}>

          {/* Período */}
          <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #e8eaed', padding: '4px 0', gap: 8, flexWrap: 'wrap' }}>
            <span style={lbl}>Período:</span>
            <div style={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
              {[{ key: 'hoje', label: 'Hoje' }, { key: 'ontem', label: 'Ontem' }, { key: '7dias', label: '7 dias' }, { key: 'mes', label: 'Mês' }, { key: 'todos', label: 'Todos' }, { key: 'favoritas', label: '⭐ Favoritas' }, { key: 'urgentes', label: '🔴 Urgente' }].map(p => (
                <button key={p.key} onClick={() => aplicarPeriodo(p.key)}
                  style={{ padding: '2px 10px', borderRadius: 3, fontSize: 12, fontWeight: filtroPeriodo === p.key ? 700 : 400, border: '1px solid', borderColor: filtroPeriodo === p.key ? '#0a1628' : '#d1d5db', background: filtroPeriodo === p.key ? '#0a1628' : '#fff', color: filtroPeriodo === p.key ? '#fff' : '#374151', cursor: 'pointer' }}>
                  {p.label}
                </button>
              ))}
            </div>
            {/* Navegador de dia (‹ Domingo, 12/07/2026 ›): clica e vê só aquele dia */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 5, background: '#0a1628', borderRadius: 6, padding: '2px 6px', opacity: filtroPeriodo === 'dia' ? 1 : 0.72 }}>
              <button onClick={() => irParaDia(somarDia(diaSel, -1))} title="Dia anterior"
                style={{ background: 'none', border: '1px solid rgba(255,255,255,0.35)', color: '#fff', borderRadius: 4, padding: '0 8px', cursor: 'pointer', fontSize: 13, lineHeight: '18px' }}>‹</button>
              <button onClick={() => irParaDia(diaSel)} title="Ver as tarefas deste dia"
                style={{ background: 'none', border: 'none', color: '#fff', fontWeight: 700, fontSize: 12.5, cursor: 'pointer', textTransform: 'capitalize', padding: '1px 4px', whiteSpace: 'nowrap', width: 176, textAlign: 'center' }}>
                {nomeDiaLongo(diaSel)}, {fmtDiaCompleto(diaSel)}
              </button>
              <button onClick={() => irParaDia(somarDia(diaSel, 1))} title="Dia seguinte"
                style={{ background: 'none', border: '1px solid rgba(255,255,255,0.35)', color: '#fff', borderRadius: 4, padding: '0 8px', cursor: 'pointer', fontSize: 13, lineHeight: '18px' }}>›</button>
            </div>
          </div>

          {/* Responsável + Status */}
          <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #e8eaed', padding: '3px 0', gap: 0, flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', flex: 2, gap: 4 }}>
              <span style={lbl}>Destinado a:</span>
              {localStorage.getItem('nomeUsuario') === 'Vagner Freitas' ? (
                <select value={filtroResponsavel} onChange={e => setFiltroResponsavel(e.target.value)} style={{ ...inp }}>
                  <option value="">Todos</option>
                  {responsaveis.map(r => <option key={r} value={r}>{r}</option>)}
                </select>
              ) : (
                // Cada login vê só a própria agenda — o servidor já filtra;
                // aqui só mostra o nome fixo, sem opção de trocar
                <span style={{ ...inp, display: 'inline-flex', alignItems: 'center', background: '#f3f4f6', color: '#374151', fontWeight: 600 }}>{filtroResponsavel || localStorage.getItem('nomeUsuario')}</span>
              )}
            </div>
            <div style={{ width: 1, background: '#e8eaed', alignSelf: 'stretch', margin: '0 8px' }} />
            <div style={{ display: 'flex', alignItems: 'center', flex: 1, gap: 4 }}>
              <span style={lbl}>Status:</span>
              <select value={filtroStatus} onChange={e => setFiltroStatus(e.target.value)} style={{ ...inp }}>
                <option value="">Todos</option>
                <option value="Pendente">Pendente (inclui atrasadas)</option>
                <option>Atrasada</option>
                <option>Feito</option>
                <option>Sem data</option>
              </select>
            </div>
          </div>

          {/* Subagenda (filtro do Vagner — também recorta o modo painéis) */}
          {isAdmin() && (
            <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #e8eaed', padding: '4px 0', gap: 8, flexWrap: 'wrap' }}>
              <span style={lbl}>Subagenda:</span>
              <div style={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
                <button onClick={() => setFiltroSubagenda('todas')} style={chipSub(filtroSubagenda === 'todas', '#0a1628')}>Todas</button>
                {SUBAGENDAS.map(s => (
                  <button key={s.key || 'geral'} onClick={() => setFiltroSubagenda(s.key)} style={chipSub(filtroSubagenda === s.key, s.cor)}>{s.icone} {s.label}</button>
                ))}
              </div>
            </div>
          )}

          {/* Datas + mostrar futuras + limpar */}
          <div style={{ display: 'flex', alignItems: 'center', padding: '3px 0', gap: 0, flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', flex: 1, gap: 4 }}>
              <span style={lbl}>Data de:</span>
              <input type="date" value={filtroDataDe} onChange={e => setFiltroDataDe(e.target.value)} style={{ ...inp }} />
            </div>
            <div style={{ width: 1, background: '#e8eaed', alignSelf: 'stretch', margin: '0 8px' }} />
            <div style={{ display: 'flex', alignItems: 'center', flex: 1, gap: 4 }}>
              <span style={lbl}>até:</span>
              <input type="date" value={filtroDataAte} onChange={e => setFiltroDataAte(e.target.value)} style={{ ...inp }} />
            </div>
            <div style={{ width: 1, background: '#e8eaed', alignSelf: 'stretch', margin: '0 8px' }} />
            <label style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, color: '#374151', cursor: 'pointer', whiteSpace: 'nowrap' }}>
              <input type="checkbox" checked={mostrarFuturas} onChange={e => setMostrarFuturas(e.target.checked)} disabled={filtroDataAtiva} />
              Futuras
            </label>
            {(filtroResponsavel || filtroStatus !== 'Pendente' || filtroDataDe || filtroDataAte || mostrarFuturas) && (
              <>
                <div style={{ width: 1, background: '#e8eaed', alignSelf: 'stretch', margin: '0 8px' }} />
                <button onClick={() => { setFiltroResponsavel(''); setFiltroStatus('Pendente'); setFiltroDataDe(''); setFiltroDataAte(''); setMostrarFuturas(false); }}
                  style={{ background: 'none', border: 'none', color: '#dc2626', fontSize: 12, cursor: 'pointer', whiteSpace: 'nowrap', fontWeight: 600 }}>
                  × Limpar
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Modo subagendas (só Vagner): painéis lado a lado, estilo Softcom */}
      {modoSub && isAdmin() ? (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 10 }}>
          {SUBAGENDAS.map(sub => {
            const ts = tarefasFiltradas.filter(t => (t.subagenda || '') === sub.key);
            const abertos = ts.filter(t => !t.realizado).length;
            return (
              <div key={sub.key || 'geral'}
                onDragOver={e => { e.preventDefault(); if (sobreSub !== sub.key) setSobreSub(sub.key); }}
                onDragLeave={e => { if (!e.currentTarget.contains(e.relatedTarget)) setSobreSub(null); }}
                onDrop={e => { e.preventDefault(); soltarNaSubagenda(sub.key); }}
                style={{ background: '#fff', border: `1px solid ${sobreSub === sub.key && arrastandoTarefa ? sub.cor : '#c8d0da'}`, borderTop: `4px solid ${sub.cor}`, borderRadius: 6, display: 'flex', flexDirection: 'column', minHeight: 170, maxHeight: 430, boxShadow: sobreSub === sub.key && arrastandoTarefa ? `0 0 0 3px ${sub.cor}33` : 'none', transition: 'box-shadow .15s, border-color .15s' }}>
                <div style={{ padding: '6px 10px', borderBottom: '1px solid #e8eaed', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontWeight: 800, fontSize: 12.5, color: '#0a1628' }}>{sub.icone} {sub.label.toUpperCase()}</span>
                  <span style={{ background: sub.cor, color: '#fff', borderRadius: 999, padding: '1px 8px', fontSize: 11, fontWeight: 800 }}>{ts.length}</span>
                </div>
                <div style={{ flex: 1, overflowY: 'auto' }}>
                  {ts.map((t, i) => {
                    const st = statusTarefa(t);
                    return (
                      <div key={t._id} title={`${t.descricao}${t.cliente_nome ? ' — ' + t.cliente_nome : ''}${t.destinado_a ? ' · ' + t.destinado_a : ''}`}
                        draggable
                        onDragStart={e => { setArrastandoTarefa(t); e.dataTransfer.effectAllowed = 'move'; }}
                        onDragEnd={() => { setArrastandoTarefa(null); setSobreSub(null); }}
                        onClick={() => setTarefaAcao(t)}
                        onMouseEnter={e => { e.currentTarget.style.filter = 'brightness(0.96)'; }}
                        onMouseLeave={e => { e.currentTarget.style.filter = 'none'; }}
                        style={{ padding: '4px 8px', borderBottom: '1px solid #f3f4f6', background: t.urgente && !t.realizado ? '#fee2e2' : i % 2 ? '#fafafa' : '#fff', display: 'flex', gap: 6, alignItems: 'baseline', cursor: 'grab', opacity: arrastandoTarefa?._id === t._id ? 0.45 : 1 }}>
                        <span style={{ fontSize: 11, fontWeight: 700, color: st.cor, whiteSpace: 'nowrap', minWidth: 34 }}>
                          {(t.data_agendada || '').includes('T') ? t.data_agendada.slice(11, 16) : (t.data_agendada ? fmtDt(t.data_agendada).slice(0, 5) : '—')}
                        </span>
                        <span style={{ flex: 1, fontSize: 12, color: t.realizado ? '#9ca3af' : '#111', textDecoration: t.realizado ? 'line-through' : 'none', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {t.urgente ? '🔴 ' : ''}{t.favorita ? '⭐ ' : ''}
                          {t.lembrete_em && !t.lembrete_enviado ? <span title={`Lembrete no WhatsApp em ${fmtDt(t.lembrete_em)}`}>🔔 </span> : ''}
                          {t.descricao}
                        </span>
                        {(t.cliente_nome || t.oportunidade_nome) && (
                          <span style={{ fontSize: 10.5, color: '#6b7280', maxWidth: 90, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.cliente_nome || t.oportunidade_nome}</span>
                        )}
                      </div>
                    );
                  })}
                  {ts.length === 0 && <div style={{ padding: 12, fontSize: 11.5, color: '#c3cad3', textAlign: 'center' }}>Nenhuma tarefa</div>}
                </div>
                <div style={{ borderTop: '1px solid #e8eaed', padding: '4px 10px', display: 'flex', gap: 12, fontSize: 11, color: '#374151', background: '#f9fafb', borderRadius: '0 0 6px 6px' }}>
                  <span>Quantidade: <b>{ts.length}</b></span>
                  <span style={{ color: '#d97706' }}>Abertos: <b>{abertos}</b></span>
                  <span style={{ color: '#15803d' }}>Fechados: <b>{ts.length - abertos}</b></span>
                </div>
              </div>
            );
          })}
        </div>
      ) : tarefasFiltradas.length === 0 ? (
        <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 4, padding: '20px', textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>
          Nenhuma tarefa encontrada.
        </div>
      ) : (
        <div style={{ border: '1px solid #c8d0da', borderRadius: 4, overflowX: 'auto' }}>
          {/* Cabeçalho tabela (minWidth: no celular a lista rola dentro do quadro) */}
          <div style={{ background: '#0a1628', display: 'grid', gridTemplateColumns: '1fr 2fr 110px 110px 110px', gap: 0, padding: '5px 10px', minWidth: 620 }}>
            {['Cliente / Origem', 'Tarefa', 'Data', 'Destinado a', 'Status'].map(h => (
              <span key={h} style={{ fontSize: 11, fontWeight: 700, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{h}</span>
            ))}
          </div>

          {tarefasFiltradas.map((t, i) => {
            const status = statusTarefa(t);
            return (
              <div key={t._id} style={{
                display: 'grid', gridTemplateColumns: '1fr 2fr 110px 110px 110px',
                alignItems: 'center', gap: 0, padding: '6px 10px', minWidth: 620,
                borderBottom: i < tarefasFiltradas.length - 1 ? '1px solid #e8eaed' : 'none',
                background: t.urgente ? '#fee2e2' : t.favorita ? '#fffbeb' : (i % 2 === 0 ? '#fafafa' : '#fff'),
              }}>
                {/* Origem */}
                <div style={{ fontSize: 12, paddingRight: 8, minWidth: 0 }}>
                  <div style={{ fontWeight: 700, color: '#0a1628', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 4 }}>
                    <button onClick={e => { e.stopPropagation(); alternarFavorita(t); }}
                      title={t.favorita ? 'Tirar dos favoritos' : 'Marcar como favorita (aparece no filtro ⭐ em qualquer dia)'}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 14, padding: 0, lineHeight: 1, opacity: t.favorita ? 1 : 0.45 }}>
                      {t.favorita ? '⭐' : '☆'}
                    </button>
                    <button onClick={e => { e.stopPropagation(); alternarUrgente(t); }}
                      title={t.urgente ? 'Tirar a urgência' : 'Marcar como URGENTE (linha vermelha + filtro 🔴)'}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 12, padding: 0, lineHeight: 1, opacity: t.urgente ? 1 : 0.3, filter: t.urgente ? 'none' : 'grayscale(1)' }}>
                      🔴
                    </button>
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{t.oportunidade_nome ? `🎯 ${t.oportunidade_nome}` : t.cliente_nome ? `👤 ${t.cliente_nome}` : '—'}</span>
                  </div>
                  {(() => {
                    const tel = (t.cliente_id && telefonesCache[t.cliente_id]) || (t.oportunidade_id && telefonesCache[`op_${t.oportunidade_id}`]) || '';
                    return tel ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 2 }}>
                        <span style={{ fontSize: 11, color: '#6b7280' }}>📞 {tel}</span>
                        <button onClick={e => { e.stopPropagation(); copiarTelefone(tel); }}
                          title="Copiar número"
                          style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 3, padding: '1px 4px', fontSize: 10, cursor: 'pointer', lineHeight: 1 }}>
                          📋
                        </button>
                      </div>
                    ) : null;
                  })()}
                  <div style={{ fontSize: 11, color: '#9ca3af' }}>Criado: {fmtDt(t.criado_em)}</div>
                  {isAdmin() && (
                    <select value={t.subagenda || ''} onClick={e => e.stopPropagation()}
                      onChange={async e => {
                        const v = e.target.value;
                        await fetch(`/agenda/${t._id}`, {
                          method: 'PUT',
                          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
                          body: JSON.stringify({ descricao: t.descricao, data_agendada: t.data_agendada, destinado_a: t.destinado_a, realizado: t.realizado || '', subagenda: v }),
                        }).catch(() => {});
                        carregar();
                      }}
                      title="Subagenda desta tarefa (alimenta o modo subagendas)"
                      style={{ marginTop: 2, fontSize: 10.5, padding: '1px 3px', borderRadius: 3, border: '1px solid #d1d5db', background: '#fff', color: (SUBAGENDAS.find(s => s.key === (t.subagenda || '')) || SUBAGENDAS[5]).cor, fontWeight: 700, maxWidth: 155 }}>
                      {SUBAGENDAS.map(s => <option key={s.key || 'g'} value={s.key}>{s.icone} {s.label}</option>)}
                    </select>
                  )}
                </div>

                {/* Tarefa — texto em destaque (maior e em negrito) */}
                <div style={{ fontSize: 12, paddingRight: 8, minWidth: 0 }}>
                  <div style={{ color: '#111', fontSize: 14, fontWeight: 700, lineHeight: 1.35, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                    {t.descricao}
                  </div>
                  {t.realizado && (
                    <div style={{ fontSize: 11, color: '#15803d', marginTop: 2 }}>✓ {t.realizado}</div>
                  )}
                </div>

                {/* Data */}
                <div style={{ fontSize: 11, color: '#374151' }}>
                  {fmtDt(t.data_agendada)}
                </div>

                {/* Destinado a */}
                <div style={{ fontSize: 12, color: '#374151', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {t.destinado_a || '—'}
                </div>

                {/* Status + ações */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'flex-start' }}>
                  <span style={{ background: status.bg, color: status.cor, padding: '1px 8px', borderRadius: 3, fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap' }}>
                    {status.label}
                  </span>
                  <div style={{ display: 'flex', gap: 4, alignItems: 'center', flexWrap: 'wrap' }}>
                    {!t.realizado && (
                      <button onClick={() => { setTarefaFeito(t); setTextoRealizado(''); }}
                        style={{ background: '#16a34a', color: '#fff', padding: '2px 8px', borderRadius: 3, fontSize: 11, fontWeight: 600, border: 'none', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                        ✓ Feito
                      </button>
                    )}
                    {!t.realizado && (
                      <button onClick={() => { setAdiarTarefa(t); setNovaDataAdiar(''); setErroAdiar(''); }}
                        title="Adiar: mover a data pra frente (nunca pro passado)"
                        style={{ background: '#0a1628', color: '#fff', padding: '2px 8px', borderRadius: 3, fontSize: 12, fontWeight: 700, border: 'none', cursor: 'pointer', lineHeight: 1.2 }}>
                        ➜
                      </button>
                    )}
                    <button onClick={() => setConfirmExcluir(t._id)}
                      title="Excluir tarefa"
                      style={{ background: 'none', color: '#dc2626', border: 'none', cursor: 'pointer', fontSize: 14, fontWeight: 700, padding: '0 2px', lineHeight: 1 }}>
                      ✕
                    </button>
                  </div>
                  {t.cliente_id && (
                    <button onClick={() => navigate(`/clientes/${t.cliente_id}/editar`)}
                      style={{ background: '#e8edf2', color: '#0a1628', padding: '2px 8px', borderRadius: 3, fontSize: 11, border: 'none', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                      Cadastro
                    </button>
                  )}
                  {t.oportunidade_id && (
                    <button onClick={() => navigate(`/crm?oportunidade=${t.oportunidade_id}`)}
                      style={{ background: '#eff6ff', color: '#1d4ed8', padding: '2px 8px', borderRadius: 3, fontSize: 11, border: 'none', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                      CRM
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Modal Calendário */}
      {modalCalendario && (() => {
        const { ano, mes } = mesCalendario;
        const nomeMes = new Date(ano, mes, 1).toLocaleString('pt-BR', { month: 'long' });
        const primeiroDia = new Date(ano, mes, 1).getDay();
        const diasNoMes = new Date(ano, mes + 1, 0).getDate();
        const hoje = new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString().slice(0, 10);

        const tarefasPorDia = {};
        tarefas.forEach(t => {
          if (!visivelPraMim(t)) return;
          if (!t.data_agendada) return;
          const dia = t.data_agendada.slice(0, 10);
          if (!tarefasPorDia[dia]) tarefasPorDia[dia] = [];
          tarefasPorDia[dia].push(t);
        });

        const celulas = [];
        for (let i = 0; i < primeiroDia; i++) celulas.push(null);
        for (let d = 1; d <= diasNoMes; d++) celulas.push(d);
        while (celulas.length % 7 !== 0) celulas.push(null);

        return (
          <div style={modalBase} onClick={() => setModalCalendario(false)}>
            <div style={{ background: '#fff', borderRadius: 6, width: 680, maxWidth: '96vw', maxHeight: '90vh', overflowY: 'auto', border: '1px solid #c8d0da' }} onClick={e => e.stopPropagation()}>
              <div style={{ background: '#0a1628', padding: '8px 14px', borderRadius: '6px 6px 0 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <button onClick={() => setMesCalendario(({ ano, mes }) => { const d = new Date(ano, mes - 1, 1); return { ano: d.getFullYear(), mes: d.getMonth() }; })}
                    style={{ background: 'none', border: '1px solid rgba(255,255,255,0.3)', color: '#fff', borderRadius: 4, padding: '2px 8px', cursor: 'pointer', fontSize: 14 }}>‹</button>
                  <span style={{ fontSize: 14, fontWeight: 700, color: '#fff', textTransform: 'capitalize', minWidth: 140, textAlign: 'center' }}>{nomeMes} {ano}</span>
                  <button onClick={() => setMesCalendario(({ ano, mes }) => { const d = new Date(ano, mes + 1, 1); return { ano: d.getFullYear(), mes: d.getMonth() }; })}
                    style={{ background: 'none', border: '1px solid rgba(255,255,255,0.3)', color: '#fff', borderRadius: 4, padding: '2px 8px', cursor: 'pointer', fontSize: 14 }}>›</button>
                </div>
                <button onClick={() => setModalCalendario(false)} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}>×</button>
              </div>
              <div style={{ padding: 14 }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 2, marginBottom: 4 }}>
                  {['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'].map(d => (
                    <div key={d} style={{ textAlign: 'center', fontSize: 11, fontWeight: 700, color: '#6b7280', padding: '2px 0' }}>{d}</div>
                  ))}
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 2 }}>
                  {celulas.map((dia, i) => {
                    if (!dia) return <div key={i} />;
                    const chave = `${ano}-${String(mes + 1).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
                    const itens = tarefasPorDia[chave] || [];
                    const ehHoje = chave === hoje;
                    return (
                      <div key={i} onClick={() => { if (itens.length > 0) { setDiaExpandido(diaExpandido === chave ? null : chave); itens.forEach(t => { if (t.cliente_id) buscarTelefone(t.cliente_id); if (t.oportunidade_id) buscarTelefoneOportunidade(t.oportunidade_id); }); } }}
                        style={{ height: 72, overflow: 'hidden', border: `1px solid ${diaExpandido === chave ? '#0a1628' : ehHoje ? '#0a1628' : '#e5e7eb'}`, borderRadius: 4, padding: '3px 4px', background: ehHoje ? '#f0f4ff' : '#fafafa', cursor: itens.length > 0 ? 'pointer' : 'default', boxShadow: diaExpandido === chave ? '0 0 0 2px #0a162844' : 'none' }}>
                        <div style={{ fontSize: 11, fontWeight: ehHoje ? 700 : 400, color: ehHoje ? '#0a1628' : '#374151', marginBottom: 2, display: 'flex', justifyContent: 'space-between' }}>
                          <span>{dia}</span>
                          {itens.length > 0 && <span style={{ fontSize: 9, background: '#0a1628', color: '#fff', borderRadius: 8, padding: '0 4px' }}>{itens.length}</span>}
                        </div>
                        {itens.slice(0, 2).map((t, j) => {
                          const st = statusTarefa(t);
                          return (
                            <div key={j} style={{ fontSize: 10, background: st.bg, color: st.cor, borderRadius: 2, padding: '1px 3px', marginBottom: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={t.descricao}>
                              {t.descricao}
                            </div>
                          );
                        })}
                        {itens.length > 2 && <div style={{ fontSize: 9, color: '#9ca3af' }}>+{itens.length - 2} mais</div>}
                      </div>
                    );
                  })}
                </div>
                {diaExpandido && tarefasPorDia[diaExpandido] && (() => {
                  const [dAno, dMes, dDia] = diaExpandido.split('-');
                  const itensExp = tarefasPorDia[diaExpandido];
                  return (
                    <div style={{ marginTop: 10, background: '#fff', border: '1px solid #0a1628', borderRadius: 6, padding: 12 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                        <span style={{ fontSize: 13, fontWeight: 700, color: '#0a1628' }}>
                          {dDia}/{dMes}/{dAno.slice(2)} — {itensExp.length} tarefa{itensExp.length !== 1 ? 's' : ''}
                        </span>
                        <button onClick={() => setDiaExpandido(null)} style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#6b7280', lineHeight: 1 }}>×</button>
                      </div>
                      {itensExp.map((t, j) => {
                        const st = statusTarefa(t);
                        return (
                          <div key={j} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, padding: '6px 8px', borderRadius: 4, background: st.bg, border: `1px solid ${st.cor}33`, marginBottom: 6 }}>
                            <span style={{ fontSize: 10, fontWeight: 700, color: st.cor, background: '#fff', border: `1px solid ${st.cor}`, borderRadius: 3, padding: '1px 5px', whiteSpace: 'nowrap', marginTop: 1 }}>{st.label}</span>
                            <div style={{ flex: 1 }}>
                              <div style={{ fontSize: 12, fontWeight: 600, color: '#0a1628' }}>{t.descricao}</div>
                              {t.cliente_nome && <div style={{ fontSize: 11, color: '#6b7280' }}>👤 {t.cliente_nome}</div>}
                              {t.oportunidade_nome && <div style={{ fontSize: 11, color: '#6b7280' }}>📋 {t.oportunidade_nome}</div>}
                              {(() => {
                                const tel = (t.cliente_id && telefonesCache[t.cliente_id]) || (t.oportunidade_id && telefonesCache[`op_${t.oportunidade_id}`]) || '';
                                return tel ? (
                                  <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginTop: 2 }}>
                                    <span style={{ fontSize: 11, color: '#6b7280' }}>📞 {tel}</span>
                                    <button onClick={e => { e.stopPropagation(); copiarTelefone(tel); }}
                                      title="Copiar número"
                                      style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 3, padding: '1px 5px', fontSize: 10, cursor: 'pointer' }}>
                                      📋
                                    </button>
                                  </div>
                                ) : null;
                              })()}
                              {t.destinado_a && <div style={{ fontSize: 11, color: '#6b7280' }}>Responsável: {t.destinado_a}</div>}
                              {t.data_agendada?.includes('T') && <div style={{ fontSize: 11, color: '#6b7280' }}>⏰ {fmtDt(t.data_agendada)}</div>}
                              {t.realizado && <div style={{ fontSize: 11, color: '#16a34a', marginTop: 2 }}>✓ {t.realizado}</div>}
                            </div>
                            {(t.cliente_id || t.oportunidade_id) && (
                              <button
                                onClick={() => {
                                  setModalCalendario(false);
                                  setDiaExpandido(null);
                                  if (t.cliente_id) navigate(`/clientes/${t.cliente_id}/editar`);
                                  else navigate('/crm');
                                }}
                                title={t.cliente_id ? 'Abrir cadastro do cliente' : 'Abrir CRM'}
                                style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 4, padding: '4px 10px', fontSize: 11, cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0, alignSelf: 'center' }}>
                                {t.cliente_id ? '👤 Ver cliente' : '📋 Ver CRM'}
                              </button>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  );
                })()}
              </div>
            </div>
          </div>
        );
      })()}

      {/* Modal de ações da tarefa (clique no painel de subagendas) */}
      {tarefaAcao && (
        <div style={modalBase} onClick={() => setTarefaAcao(null)}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 6, width: 440, maxWidth: '94vw', border: '1px solid #c8d0da' }}>
            <div style={{ background: '#0a1628', padding: '8px 14px', borderRadius: '6px 6px 0 0', color: '#fff', fontWeight: 700, fontSize: 14 }}>
              {(SUBAGENDAS.find(x => x.key === (tarefaAcao.subagenda || '')) || SUBAGENDAS[5]).icone} Tarefa
            </div>
            <div style={{ padding: 14 }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#0a1628', lineHeight: 1.4 }}>
                {tarefaAcao.urgente ? '🔴 ' : ''}{tarefaAcao.favorita ? '⭐ ' : ''}{tarefaAcao.descricao}
              </div>
              {(tarefaAcao.cliente_nome || tarefaAcao.oportunidade_nome) && (
                <div style={{ fontSize: 12, color: '#6b7280', marginTop: 5 }}>
                  {tarefaAcao.oportunidade_nome ? `🎯 ${tarefaAcao.oportunidade_nome}` : `👤 ${tarefaAcao.cliente_nome}`}
                </div>
              )}
              {(tarefaAcao.cliente_id || tarefaAcao.oportunidade_id) && (() => {
                const tel = (tarefaAcao.cliente_id && telefonesCache[tarefaAcao.cliente_id])
                  || (tarefaAcao.oportunidade_id && telefonesCache[`op_${tarefaAcao.oportunidade_id}`]) || '';
                const buscando = tarefaAcao.cliente_id
                  ? telefonesCache[tarefaAcao.cliente_id] === undefined
                  : telefonesCache[`op_${tarefaAcao.oportunidade_id}`] === undefined;
                const num = tel.replace(/\D/g, '');
                return (
                  <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2, display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                    <span>📞 {tel ? <strong style={{ color: '#0a1628' }}>{tel}</strong> : (buscando ? 'buscando…' : <em style={{ color: '#9ca3af' }}>sem telefone no cadastro</em>)}</span>
                    {tel && (
                      <>
                        <button onClick={() => copiarTelefone(tel)} title="Copiar só os números"
                          style={{ background: '#fff', border: '1px solid #d1d5db', borderRadius: 4, padding: '1px 8px', fontSize: 11, color: '#374151', cursor: 'pointer' }}>📋 copiar</button>
                        <a href={`https://wa.me/${num.length <= 11 ? '55' + num : num}`} target="_blank" rel="noreferrer"
                          style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 4, padding: '1px 8px', fontSize: 11, color: '#15803d', fontWeight: 600, textDecoration: 'none' }}>WhatsApp</a>
                      </>
                    )}
                  </div>
                );
              })()}
              {tarefaAcao.data_agendada && <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>📅 {fmtDt(tarefaAcao.data_agendada)}</div>}
              {tarefaAcao.destinado_a && <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>Responsável: {tarefaAcao.destinado_a}</div>}
              {tarefaAcao.oportunidade_id && (() => {
                // Etapa da negociação no CRM: mostra a coluna atual e move daqui mesmo
                const ETAPAS_CRM = [
                  { key: 'lead', label: 'Lead', cor: '#6b7280' },
                  { key: '1contato', label: '1º Contato', cor: '#3b82f6' },
                  { key: 'viabilidade', label: 'Viabilidade', cor: '#f59e0b' },
                  { key: 'negociacao', label: 'Negociação', cor: '#8b5cf6' },
                  { key: 'ganho', label: 'Ganho', cor: '#16a34a' },
                  { key: 'perdido', label: 'Perdido', cor: '#dc2626' },
                  { key: 'sem-interacao', label: 'Sem interação', cor: '#9ca3af' },
                ];
                const atual = etapaOps[tarefaAcao.oportunidade_id];
                return (
                  <div style={{ marginTop: 8, background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 6, padding: '7px 10px' }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', marginBottom: 5 }}>
                      Coluna no CRM {atual === undefined && <span style={{ fontWeight: 400, textTransform: 'none' }}>· carregando…</span>}
                    </div>
                    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                      {ETAPAS_CRM.map(e => {
                        const on = atual === e.key;
                        return (
                          <button key={e.key} onClick={() => !on && mudarEtapaOp(tarefaAcao.oportunidade_id, e.key)}
                            title={on ? 'Coluna atual' : `Mover para ${e.label}`}
                            style={{ background: on ? e.cor : '#fff', color: on ? '#fff' : e.cor, border: `1px solid ${e.cor}`, borderRadius: 4, padding: '2px 8px', fontSize: 11, fontWeight: 700, cursor: on ? 'default' : 'pointer', opacity: atual === undefined ? 0.5 : 1 }}>
                            {e.label}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                );
              })()}
              {tarefaAcao.realizado && <div style={{ fontSize: 12, color: '#15803d', marginTop: 2 }}>✓ {tarefaAcao.realizado}</div>}
              {/* ⭐/🔴: alternam na hora e o modal acompanha */}
              <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                <button type="button"
                  onClick={() => { alternarFavorita(tarefaAcao); setTarefaAcao(a => ({ ...a, favorita: !a.favorita })); }}
                  style={{ background: tarefaAcao.favorita ? '#fffbeb' : '#fff', color: tarefaAcao.favorita ? '#b45309' : '#6b7280', border: `1px solid ${tarefaAcao.favorita ? '#fde68a' : '#d1d5db'}`, borderRadius: 4, padding: '4px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                  {tarefaAcao.favorita ? '⭐ Favorita' : '☆ Favorita'}
                </button>
                <button type="button"
                  onClick={() => { alternarUrgente(tarefaAcao); setTarefaAcao(a => ({ ...a, urgente: !a.urgente })); }}
                  style={{ background: tarefaAcao.urgente ? '#fee2e2' : '#fff', color: tarefaAcao.urgente ? '#b91c1c' : '#6b7280', border: `1px solid ${tarefaAcao.urgente ? '#fecaca' : '#d1d5db'}`, borderRadius: 4, padding: '4px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                  {tarefaAcao.urgente ? '🔴 Urgente' : '⚪ Urgente'}
                </button>
                <button type="button" onClick={() => abrirLembrete(tarefaAcao)}
                  title="Receber um lembrete desta tarefa no WhatsApp, na data e hora que você escolher"
                  style={{ background: tarefaAcao.lembrete_em ? '#eff6ff' : '#fff', color: tarefaAcao.lembrete_em ? '#1d4ed8' : '#6b7280', border: `1px solid ${tarefaAcao.lembrete_em ? '#bfdbfe' : '#d1d5db'}`, borderRadius: 4, padding: '4px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                  {tarefaAcao.lembrete_em ? `🔔 ${fmtDt(tarefaAcao.lembrete_em)}` : '🔔 Me lembrar'}
                </button>
              </div>
              {/* Ações da tarefa (adiar, mensagem, atalhos) */}
              {(!tarefaAcao.realizado || tarefaAcao.cliente_id || tarefaAcao.oportunidade_id) && (
                <div style={{ display: 'flex', gap: 8, marginTop: 12, flexWrap: 'wrap' }}>
                  {!tarefaAcao.realizado && (
                    <BtnCancel onClick={() => { const t = tarefaAcao; setTarefaAcao(null); setNovaDataAdiar(''); setErroAdiar(''); setAdiarTarefa(t); }}>➜ Adiar</BtnCancel>
                  )}
                  {(tarefaAcao.cliente_id || tarefaAcao.oportunidade_id) && (
                    <BtnCancel onClick={() => abrirMsgCliente(tarefaAcao)}
                      style={{ color: '#15803d', borderColor: '#bbf7d0' }}>💬 Mensagem pro cliente</BtnCancel>
                  )}
                  {tarefaAcao.cliente_id && (
                    <BtnCancel onClick={() => navigate(`/clientes/${tarefaAcao.cliente_id}/editar`)}>📇 Abrir cadastro</BtnCancel>
                  )}
                  {tarefaAcao.oportunidade_id && (
                    <BtnCancel onClick={() => navigate(`/crm?oportunidade=${tarefaAcao.oportunidade_id}`)}
                      title="Abre o CRM já com o card desta negociação aberto">📋 Abrir CRM</BtnCancel>
                  )}
                </div>
              )}
              {/* Rodapé: destrutiva isolada à esquerda; sair e concluir à direita */}
              <div style={{ display: 'flex', gap: 8, marginTop: 14, alignItems: 'center', borderTop: '1px solid #e8eaed', paddingTop: 10 }}>
                <BtnCancel onClick={() => { const t = tarefaAcao; setTarefaAcao(null); setConfirmExcluir(t._id); }}
                  style={{ color: '#dc2626', borderColor: '#fecaca' }}>🗑 Excluir</BtnCancel>
                <span style={{ flex: 1 }} />
                <BtnCancel onClick={() => setTarefaAcao(null)}>Fechar</BtnCancel>
                {!tarefaAcao.realizado && (
                  <BtnPrimary onClick={() => { const t = tarefaAcao; setTarefaAcao(null); setTextoRealizado(''); setTarefaFeito(t); }}
                    style={{ background: '#16a34a' }}>✓ Feito</BtnPrimary>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 💬 Mensagem agendada pro cliente */}
      {msgAlvo && <AgendarMensagemCliente alvo={msgAlvo} onFechar={() => setMsgAlvo(null)} />}

      {/* 🔔 Modal do lembrete no WhatsApp */}
      {lembreteTarefa && (
        <div style={modalBase} onClick={() => setLembreteTarefa(null)}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 6, width: 420, maxWidth: '94vw', border: '1px solid #c8d0da' }}>
            <div style={{ background: '#0a1628', padding: '8px 14px', borderRadius: '6px 6px 0 0', color: '#fff', fontWeight: 700, fontSize: 14 }}>
              🔔 Me lembrar no WhatsApp
            </div>
            <div style={{ padding: 14 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628', lineHeight: 1.4 }}>{lembreteTarefa.descricao}</div>
              {lembreteTarefa.data_agendada && (
                <div style={{ fontSize: 12, color: '#6b7280', marginTop: 3 }}>📅 Agendada para {fmtDt(lembreteTarefa.data_agendada)}</div>
              )}
              <div style={{ fontSize: 12, color: '#6b7280', margin: '12px 0 5px' }}>Quando você quer ser avisado?</div>
              <CampoDataHora value={quandoLembrete} onChange={v => { setQuandoLembrete(v); setErroLembrete(''); }} style={{ ...inp, width: '100%' }} />
              <div style={{ display: 'flex', gap: 6, marginTop: 8, flexWrap: 'wrap' }}>
                {[['Em 1 hora', 1], ['Em 3 horas', 3], ['Amanhã 9h', -1], ['Segunda 9h', -2]].map(([rot, h]) => (
                  <button key={rot} type="button" onClick={() => {
                    const d = new Date(Date.now() - 3 * 3600000);
                    if (h > 0) d.setUTCHours(d.getUTCHours() + h);
                    else if (h === -1) { d.setUTCDate(d.getUTCDate() + 1); d.setUTCHours(9, 0, 0, 0); }
                    else { d.setUTCDate(d.getUTCDate() + ((8 - d.getUTCDay()) % 7 || 7)); d.setUTCHours(9, 0, 0, 0); }
                    setQuandoLembrete(d.toISOString().slice(0, 16)); setErroLembrete('');
                  }} style={{ background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 4, padding: '3px 9px', fontSize: 11, cursor: 'pointer', color: '#374151' }}>{rot}</button>
                ))}
              </div>
              <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 9 }}>
                A mensagem vai para o WhatsApp do responsável pela tarefa (ou para o seu, se não houver telefone cadastrado).
              </div>
              {erroLembrete && <div style={{ color: '#dc2626', fontSize: 12, marginTop: 8 }}>⚠ {erroLembrete}</div>}
              <div style={{ display: 'flex', gap: 8, marginTop: 14, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                <BtnCancel onClick={() => setLembreteTarefa(null)}>Cancelar</BtnCancel>
                {lembreteTarefa.lembrete_em && (
                  <BtnCancel onClick={cancelarLembrete} disabled={salvandoLembrete}
                    style={{ color: '#b91c1c', borderColor: '#fecaca' }}>🔕 Remover lembrete</BtnCancel>
                )}
                <BtnPrimary onClick={confirmarLembrete} disabled={salvandoLembrete}>
                  {salvandoLembrete ? 'Salvando…' : '🔔 Agendar aviso'}
                </BtnPrimary>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Nova Tarefa */}
      {modal && (
        <div style={modalBase} onClick={() => setModal(false)}>
          <div style={{ background: '#fff', borderRadius: 6, width: 520, maxWidth: '95vw', maxHeight: '90vh', overflowY: 'auto', border: '1px solid #c8d0da' }} onClick={e => e.stopPropagation()}>
            <div style={{ background: '#0a1628', padding: '8px 14px', borderRadius: '6px 6px 0 0' }}>
              <span style={{ fontSize: 14, fontWeight: 700, color: '#fff' }}>Nova Tarefa</span>
            </div>
            <div style={{ padding: '10px 14px', display: 'flex', flexDirection: 'column', gap: 0 }}>

              {/* Cliente (opcional: sem ele a tarefa nasce avulsa) */}
              <div style={{ borderBottom: '1px solid #e8eaed', padding: '4px 0', marginBottom: 4 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>
                  Cliente <span style={{ fontWeight: 400, color: '#9ca3af' }}>(opcional — vazio cria tarefa avulsa)</span>
                </div>
                {clienteSelecionado ? (
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f0f4ff', borderRadius: 3, padding: '4px 8px', border: '1px solid #0a162833' }}>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: 13, color: '#0a1628' }}>{clienteSelecionado.nome || clienteSelecionado.processos?.[0]?.nome_marca || 'Cliente'}</div>
                      {clienteSelecionado.processos?.[0]?.nome_marca && clienteSelecionado.nome && (
                        <div style={{ fontSize: 11, color: '#6b7280' }}>{clienteSelecionado.processos[0].nome_marca}</div>
                      )}
                    </div>
                    <button onClick={() => setClienteSelecionado(null)} style={{ background: 'none', border: 'none', color: '#dc2626', cursor: 'pointer', fontSize: 16 }}>×</button>
                  </div>
                ) : (
                  <div>
                    <input value={buscaCliente} onChange={e => setBuscaCliente(e.target.value)} placeholder="Buscar por nome, marca ou nº processo..." style={{ ...inp }} autoFocus />
                    {buscaCliente && (
                      <div style={{ border: '1px solid #c8d0da', borderRadius: 3, marginTop: 2, overflow: 'hidden', maxHeight: 180, overflowY: 'auto' }}>
                        {clientesFiltrados.length === 0 ? (
                          <div style={{ padding: '6px 10px', fontSize: 12, color: '#9ca3af' }}>Nenhum cliente encontrado</div>
                        ) : clientesFiltrados.map(c => (
                          <div key={c._id} onClick={() => { setClienteSelecionado(c); setBuscaCliente(''); }}
                            style={{ padding: '6px 10px', cursor: 'pointer', borderBottom: '1px solid #f3f4f6', fontSize: 13 }}
                            onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
                            onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                            <div style={{ fontWeight: 600, color: '#0a1628' }}>{c.nome || '(sem nome)'}</div>
                            {c.processos?.[0]?.nome_marca && <div style={{ fontSize: 11, color: '#6b7280' }}>{c.processos[0].nome_marca} — {c.processos[0].numero_processo}</div>}
                          </div>
                        ))}
                      </div>
                    )}
                    {!buscaCliente && (
                      <div style={{ fontSize: 11, color: '#b45309', marginTop: 4 }}>
                        ℹ️ Sem cliente selecionado: ao salvar, cria uma <strong>tarefa avulsa</strong> (sem vínculo).
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Descrição */}
              <div style={{ display: 'flex', alignItems: 'flex-start', borderBottom: '1px solid #e8eaed', padding: '3px 0' }}>
                <span style={{ ...lbl, paddingTop: 4 }}>Descrição *:</span>
                <textarea value={form.descricao} onChange={e => setForm(f => ({ ...f, descricao: e.target.value }))} rows={2}
                  placeholder="Descreva o que precisa ser feito..."
                  style={{ flex: 1, resize: 'vertical', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, fontFamily: 'inherit' }} />
              </div>

              {/* Data + Destinado a */}
              <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #e8eaed', padding: '3px 0', gap: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', flex: 1, gap: 4 }}>
                  <span style={lbl}>Data:</span>
                  <DataHoraInput value={form.data_agendada} onChange={v => setForm(f => ({ ...f, data_agendada: v }))} />
                </div>
                <div style={{ width: 1, background: '#e8eaed', alignSelf: 'stretch', margin: '0 8px' }} />
                <div style={{ display: 'flex', alignItems: 'center', flex: 1, gap: 4 }}>
                  <span style={lbl}>Para:</span>
                  <div style={{ flex: 1 }}>
                    <SelectColaborador value={form.destinado_a} onChange={v => setForm(f => ({ ...f, destinado_a: v }))} placeholder="Selecione..." style={{ marginTop: 0 }} />
                  </div>
                </div>
              </div>

              {/* Subagenda (classificação do modo painéis) */}
              <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #e8eaed', padding: '3px 0', gap: 4 }}>
                <span style={lbl}>Subagenda:</span>
                <select value={form.subagenda || ''} onChange={e => setForm(f => ({ ...f, subagenda: e.target.value }))} style={{ ...inp, flex: 1, width: 'auto' }}>
                  {SUBAGENDAS.map(s => <option key={s.key || 'g'} value={s.key}>{s.icone} {s.label}</option>)}
                </select>
              </div>

              {/* O que foi feito */}
              <div style={{ display: 'flex', alignItems: 'flex-start', padding: '3px 0' }}>
                <span style={{ ...lbl, paddingTop: 4 }}>Realizado:</span>
                <textarea value={form.realizado} onChange={e => setForm(f => ({ ...f, realizado: e.target.value }))} rows={2}
                  placeholder="Preencherá após realização..."
                  style={{ flex: 1, resize: 'vertical', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, fontFamily: 'inherit' }} />
              </div>

              <div style={{ display: 'flex', gap: 8, marginTop: 10, alignItems: 'center' }}>
                <BtnPrimary onClick={salvarTarefa} disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar Tarefa'}</BtnPrimary>
                <BtnCancel onClick={() => setModal(false)}>Cancelar</BtnCancel>
                <button type="button" onClick={() => setForm(f => ({ ...f, lembrarWa: !f.lembrarWa }))} title="Receber aviso no seu WhatsApp 30 minutos antes da data/hora da tarefa (precisa preencher a hora)" style={{ marginLeft: 'auto', background: form.lembrarWa ? '#eff6ff' : '#fff', color: form.lembrarWa ? '#1d4ed8' : '#6b7280', border: `1px solid ${form.lembrarWa ? '#bfdbfe' : '#d1d5db'}`, borderRadius: 4, padding: '4px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{form.lembrarWa ? '🔔 Lembrar no WhatsApp' : '🔕 Lembrar no WhatsApp'}</button>
                <button type="button" onClick={() => setForm(f => ({ ...f, favorita: !f.favorita }))} title="Favorita: aparece no filtro ⭐ em qualquer dia" style={{ background: form.favorita ? '#fffbeb' : '#fff', color: form.favorita ? '#b45309' : '#6b7280', border: `1px solid ${form.favorita ? '#fde68a' : '#d1d5db'}`, borderRadius: 4, padding: '4px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{form.favorita ? '⭐ Favorita' : '☆ Marcar favorita'}</button>
                <button type="button" onClick={() => setForm(f => ({ ...f, urgente: !f.urgente }))} title="Urgente: linha vermelha + filtro 🔴 em qualquer dia" style={{ background: form.urgente ? '#fee2e2' : '#fff', color: form.urgente ? '#b91c1c' : '#6b7280', border: `1px solid ${form.urgente ? '#fecaca' : '#d1d5db'}`, borderRadius: 4, padding: '4px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{form.urgente ? '🔴 Urgente' : '⚪ Urgente'}</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Marcar como Feito */}
      {tarefaFeito && (
        <div style={modalBase} onClick={() => setTarefaFeito(null)}>
          <div style={{ background: '#fff', borderRadius: 6, width: 440, maxWidth: '95vw', border: '1px solid #c8d0da' }} onClick={e => e.stopPropagation()}>
            <div style={{ background: '#0a1628', padding: '8px 14px', borderRadius: '6px 6px 0 0' }}>
              <span style={{ fontSize: 14, fontWeight: 700, color: '#fff' }}>Marcar como feito</span>
            </div>
            <div style={{ padding: '10px 14px' }}>
              <div style={{ fontSize: 12, color: '#374151', background: '#f9fafb', padding: '6px 8px', borderRadius: 3, marginBottom: 10, border: '1px solid #e5e7eb' }}>{tarefaFeito.descricao}</div>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 4 }}>
                <span style={{ ...lbl, paddingTop: 4 }}>O que foi feito:</span>
                <textarea value={textoRealizado} onChange={e => setTextoRealizado(e.target.value)} rows={3}
                  placeholder="Descreva o que foi realizado (opcional)..."
                  style={{ flex: 1, resize: 'vertical', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, fontFamily: 'inherit' }} />
              </div>
              <div style={{ display: 'flex', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
                <button onClick={() => confirmarFeito(false)} disabled={marcandoFeito}
                  style={{ background: '#16a34a', color: '#fff', padding: '5px 16px', borderRadius: 4, fontSize: 13, fontWeight: 600, border: 'none', cursor: 'pointer' }}>
                  {marcandoFeito ? 'Salvando...' : '✓ Confirmar Feito'}
                </button>
                <button onClick={() => confirmarFeito(true)} disabled={marcandoFeito}
                  title="Conclui esta e já abre a próxima tarefa com o mesmo cliente/oportunidade"
                  style={{ background: '#fff', color: '#16a34a', padding: '5px 14px', borderRadius: 4, fontSize: 13, fontWeight: 700, border: '1.5px solid #16a34a', cursor: 'pointer' }}>
                  ✓ Feito + nova tarefa
                </button>
                <BtnCancel onClick={() => setTarefaFeito(null)}>Cancelar</BtnCancel>
              </div>
            </div>
          </div>
        </div>
      )}

      {modalTransferir && (() => {
        // Mesma regra da ação de transferir: respeita o responsável filtrado
        // (a prévia mostrava tarefas de outros que a transferência nem movia)
        const pendentes = modoTransferir === 'atrasadas'
          ? atrasadas
          : tarefas.filter(t => visivelPraMim(t) && !t.realizado && t.data_agendada && (!dataOrigem || t.data_agendada.slice(0, 10) === dataOrigem));
        return (
          <div style={modalBase} onClick={() => setModalTransferir(false)}>
            <div style={{ background: '#fff', borderRadius: 6, width: 480, maxWidth: '95vw', maxHeight: '90vh', overflowY: 'auto', border: '1px solid #c8d0da' }} onClick={e => e.stopPropagation()}>
              <div style={{ background: '#0a1628', padding: '8px 14px', borderRadius: '6px 6px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: 14, fontWeight: 700, color: '#fff' }}>📦 Transferir Tarefas Pendentes</span>
                <button onClick={() => setModalTransferir(false)} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}>×</button>
              </div>
              <div style={{ padding: '12px 14px' }}>
                {/* De onde vêm: todas as atrasadas (sem precisar saber o dia) ou um dia específico */}
                <div style={{ display: 'flex', gap: 6, marginBottom: 12 }}>
                  {[
                    { k: 'atrasadas', label: `⏰ Todas as atrasadas (${atrasadas.length})` },
                    { k: 'dia', label: '📅 Um dia específico' },
                  ].map(o => (
                    <button key={o.k} onClick={() => setModoTransferir(o.k)}
                      style={{ flex: 1, padding: '6px 10px', fontSize: 12, fontWeight: 700, borderRadius: 6, cursor: 'pointer', border: '1px solid ' + (modoTransferir === o.k ? '#b45309' : '#d1d5db'), background: modoTransferir === o.k ? '#fffbeb' : '#fff', color: modoTransferir === o.k ? '#b45309' : '#374151' }}>
                      {o.label}
                    </button>
                  ))}
                </div>
                <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
                  {modoTransferir === 'dia' && (
                    <>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Data de origem:</div>
                        <input type="date" value={dataOrigem} onChange={e => setDataOrigem(e.target.value)}
                          style={{ padding: '5px 8px', borderRadius: 4, border: '1px solid #b0b8c4', fontSize: 13, width: '100%', boxSizing: 'border-box' }} />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: 6, fontSize: 18, color: '#9ca3af' }}>→</div>
                    </>
                  )}
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Data de destino:</div>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <input type="date" value={dataDestino} onChange={e => setDataDestino(e.target.value)}
                        style={{ padding: '5px 8px', borderRadius: 4, border: '1px solid #b0b8c4', fontSize: 13, flex: 1, boxSizing: 'border-box' }} />
                      {dataDestino !== hojeStr && (
                        <button onClick={() => setDataDestino(hojeStr)}
                          style={{ background: '#fff', color: '#374151', border: '1px solid #d1d5db', borderRadius: 4, padding: '4px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>Hoje</button>
                      )}
                    </div>
                  </div>
                </div>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6 }}>
                  {pendentes.length} tarefa(s) pendente(s) {modoTransferir === 'atrasadas' ? 'atrasada(s) — cada uma mostra o dia em que ficou' : 'na data de origem'}:
                </div>
                <div style={{ maxHeight: 240, overflowY: 'auto', border: '1px solid #e5e7eb', borderRadius: 4, marginBottom: 12 }}>
                  {pendentes.length === 0 ? (
                    <div style={{ padding: '10px 12px', fontSize: 12, color: '#9ca3af', textAlign: 'center' }}>Nenhuma tarefa pendente.</div>
                  ) : pendentes.map((t, i) => (
                    <div key={t._id} style={{ padding: '6px 10px', borderBottom: i < pendentes.length - 1 ? '1px solid #f3f4f6' : 'none', background: i % 2 === 0 ? '#fafafa' : '#fff' }}>
                      <div style={{ fontSize: 12, fontWeight: 600, color: '#0a1628' }}>{t.descricao}</div>
                      <div style={{ fontSize: 11, color: '#9ca3af' }}>
                        {t.cliente_nome || t.oportunidade_nome || '—'} · {fmtDt(t.data_agendada)}
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <BtnPrimary onClick={transferirTarefas} disabled={transferindo || pendentes.length === 0}>
                    {transferindo ? 'Transferindo...' : `Transferir ${pendentes.length} tarefa(s)`}
                  </BtnPrimary>
                  <BtnCancel onClick={() => setModalTransferir(false)}>Cancelar</BtnCancel>
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {confirmExcluir && (
        <ModalConfirmar
          mensagem="Deseja excluir esta tarefa?"
          onConfirmar={() => excluirTarefa(confirmExcluir)}
          onCancelar={() => setConfirmExcluir(null)}
        />
      )}

      {/* ➜ Adiar tarefa: data individual, sempre pra frente */}
      {adiarTarefa && (() => {
        const dataAtual = (adiarTarefa.data_agendada || '').slice(0, 10);
        const minimo = dataAtual && dataAtual >= hojeStr ? somarDia(dataAtual, 1) : hojeStr;
        return (
          <div style={modalBase} onClick={() => setAdiarTarefa(null)}>
            <div style={{ background: '#fff', borderRadius: 6, width: 420, maxWidth: '95vw', border: '1px solid #c8d0da' }} onClick={e => e.stopPropagation()}>
              <div style={{ background: '#0a1628', padding: '8px 14px', borderRadius: '6px 6px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: 14, fontWeight: 700, color: '#fff' }}>➜ Adiar tarefa</span>
                <button onClick={() => setAdiarTarefa(null)} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}>×</button>
              </div>
              <div style={{ padding: '10px 14px' }}>
                <div style={{ fontSize: 12, color: '#374151', background: '#f9fafb', padding: '6px 8px', borderRadius: 3, marginBottom: 10, border: '1px solid #e5e7eb' }}>
                  {adiarTarefa.descricao}
                </div>
                <div style={{ display: 'flex', gap: 12, alignItems: 'flex-end', flexWrap: 'wrap', marginBottom: 8 }}>
                  <div>
                    <span style={{ fontSize: 11, fontWeight: 600, color: '#6b7280', display: 'block', marginBottom: 2 }}>Data atual</span>
                    <span style={{ fontSize: 14, fontWeight: 700, color: '#0a1628' }}>{dataAtual ? fmtDt(dataAtual) : 'sem data'}</span>
                  </div>
                  <span style={{ fontSize: 18, color: '#9ca3af', paddingBottom: 2 }}>➜</span>
                  <div>
                    <span style={{ fontSize: 11, fontWeight: 600, color: '#6b7280', display: 'block', marginBottom: 2 }}>Nova data (a partir de {fmtDt(minimo)})</span>
                    <input type="date" value={novaDataAdiar} min={minimo}
                      onChange={e => { setNovaDataAdiar(e.target.value); setErroAdiar(''); }}
                      style={{ ...inp, width: 150 }} />
                  </div>
                </div>
                <div style={{ fontSize: 11, color: '#9ca3af', marginBottom: 8 }}>Só pra frente: nunca pra uma data no passado{dataAtual && dataAtual >= hojeStr ? ' nem antes da data atual' : ''}. A hora, se houver, é mantida.</div>
                {erroAdiar && <div style={{ color: '#dc2626', fontSize: 12, marginBottom: 8 }}>⚠ {erroAdiar}</div>}
                <div style={{ display: 'flex', gap: 8 }}>
                  <BtnPrimary onClick={confirmarAdiar} disabled={adiando}>{adiando ? 'Adiando…' : '➜ Adiar'}</BtnPrimary>
                  <BtnCancel onClick={() => setAdiarTarefa(null)}>Cancelar</BtnCancel>
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {/* Nova tarefa na sequência (após "✓ Feito + nova tarefa") */}
      {proximaDe && (
        <div style={modalBase} onClick={() => setProximaDe(null)}>
          <div style={{ background: '#fff', borderRadius: 6, width: 460, maxWidth: '95vw', border: '1px solid #c8d0da' }} onClick={e => e.stopPropagation()}>
            <div style={{ background: '#0a1628', padding: '8px 14px', borderRadius: '6px 6px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: 14, fontWeight: 700, color: '#fff' }}>📝 Nova tarefa na sequência</span>
              <button onClick={() => setProximaDe(null)} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}>×</button>
            </div>
            <div style={{ padding: '10px 14px' }}>
              <div style={{ fontSize: 12, color: '#166534', background: '#f0fdf4', padding: '6px 8px', borderRadius: 3, marginBottom: 10, border: '1px solid #bbf7d0' }}>
                ✓ Anterior concluída{proximaDe.descricao ? `: "${proximaDe.descricao.slice(0, 60)}${proximaDe.descricao.length > 60 ? '…' : ''}"` : ''}.
                {(proximaDe.oportunidade_nome || proximaDe.cliente_nome)
                  ? <> A nova herda o vínculo: <strong>{proximaDe.oportunidade_nome ? `🎯 ${proximaDe.oportunidade_nome}` : `👤 ${proximaDe.cliente_nome}`}</strong>.</>
                  : ' A nova entra sem vínculo (tarefa avulsa).'}
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', borderBottom: '1px solid #e8eaed', padding: '3px 0' }}>
                <span style={{ ...lbl, paddingTop: 4 }}>Descrição *:</span>
                <textarea value={proxima.descricao} onChange={e => setProxima(f => ({ ...f, descricao: e.target.value }))} rows={2} autoFocus
                  placeholder="O que fazer em seguida…"
                  style={{ flex: 1, resize: 'vertical', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, fontFamily: 'inherit' }} />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #e8eaed', padding: '3px 0', gap: 0, flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', alignItems: 'center', flex: 1, gap: 4, minWidth: 220 }}>
                  <span style={lbl}>Data:</span>
                  <DataHoraInput value={proxima.data_agendada} onChange={v => setProxima(f => ({ ...f, data_agendada: v }))} />
                </div>
                <div style={{ width: 1, background: '#e8eaed', alignSelf: 'stretch', margin: '0 8px' }} />
                <div style={{ display: 'flex', alignItems: 'center', flex: 1, gap: 4, minWidth: 180 }}>
                  <span style={lbl}>Para:</span>
                  <div style={{ flex: 1 }}>
                    <SelectColaborador value={proxima.destinado_a} onChange={v => setProxima(f => ({ ...f, destinado_a: v }))} placeholder="Selecione..." style={{ marginTop: 0 }} />
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', gap: 8, marginTop: 10, alignItems: 'center' }}>
                <BtnPrimary onClick={salvarProxima} disabled={salvandoProxima}>{salvandoProxima ? 'Salvando...' : 'Salvar Tarefa'}</BtnPrimary>
                <BtnCancel onClick={() => setProximaDe(null)}>Cancelar</BtnCancel>
                <button type="button" onClick={() => setProxima(f => ({ ...f, favorita: !f.favorita }))} title="Favorita: aparece no filtro ⭐ em qualquer dia"
                  style={{ marginLeft: 'auto', background: proxima.favorita ? '#fffbeb' : '#fff', color: proxima.favorita ? '#b45309' : '#6b7280', border: `1px solid ${proxima.favorita ? '#fde68a' : '#d1d5db'}`, borderRadius: 4, padding: '4px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                  {proxima.favorita ? '⭐ Favorita' : '☆ Marcar favorita'}
                </button>
                <button type="button" onClick={() => setProxima(f => ({ ...f, urgente: !f.urgente }))} title="Urgente: linha vermelha + filtro 🔴 em qualquer dia"
                  style={{ background: proxima.urgente ? '#fee2e2' : '#fff', color: proxima.urgente ? '#b91c1c' : '#6b7280', border: `1px solid ${proxima.urgente ? '#fecaca' : '#d1d5db'}`, borderRadius: 4, padding: '4px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                  {proxima.urgente ? '🔴 Urgente' : '⚪ Urgente'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
